export enum SanctionChildActionKind {
	ActivityProhibition = 1,
	ActivityRenewal = 2,
	SupplyProhibition = 3,
	SupplyRenewal = 4,
	ProtocolOutcome = 5,
	UnpaidFineProtocol = 6,
}
